export enum StorageChargeCurrency {
  INR = "INR",
  USD = "USD",
}

export interface CustomerStorageConfig {
  id?: number;
  customer_id?: number;
  currency: StorageChargeCurrency | "INR" | "USD";
  s_labour_charge?: number | string | null;
  s_package_charge?: number | string | null;
  s_storage_charge?: number | string | null;
  m_labour_charge?: number | string | null;
  m_package_charge?: number | string | null;
  m_storage_charge?: number | string | null;
  l_labour_charge?: number | string | null;
  l_package_charge?: number | string | null;
  l_storage_charge?: number | string | null;
  sp_labour_charge?: number | string | null;
  sp_package_charge?: number | string | null;
  sp_storage_charge?: number | string | null;
  modified_by?: number;
  created_date?: Date | string;
  modified_date?: Date | string;
  charges?: Array<{
    size: "S" | "M" | "L" | "SP";
    labour_charge?: number | string | null;
    package_charge?: number | string | null;
    storage_charge?: number | string | null;
  }>;
}

export interface Customer {
  id?: number;
  config_id?: number;
  name?: string;
  legal_name?: string;
  zoho_id?: string;
  hr_order_id?: string;
  marketing_order_id?: string;
  goldstandard_order_id?: string;
  is_parent?: boolean;
  super_customer_id?: number;
  mark_up_percentage?: number;
  parent_customer_id?: boolean;
  config?: Config;
  storage_config?: CustomerStorageConfig;
  domain?: string;
  is_partner?: boolean;
  is_demo?: boolean;
  is_deleted?: boolean | number;
  created_date?: Date;
  modified_date?: Date;
}

export interface CustomerRequestBody {
  id?: number;
  name?: string;
  legal_name?: string;
  redemption_url?: string;
  redemption_email?: string;
  redemption_email_from?: string;
  linkedin_id?: string;
  enable_coupon_redemption?: boolean;
  enable_email_redemption?: boolean;
  enable_inventory?: boolean;
  enable_goc?: boolean;
  enable_campaigns?: boolean;
  enable_swagstore?: boolean;
  enable_shopify?: boolean;
  is_sez?: boolean;
  inventory_type?: string;
  hr_order_id?: string;
  marketing_order_id?: string;
  goldstandard_order_id?: string;
  is_partner?: boolean;
  zoho_id?: string;
  enable_alert?: boolean;
  alert_type?: CustomerAlertType | string;
  redirect_redemptions_to_linkedin?: boolean;
  storage_config?: CustomerStorageConfig;
}

export enum CustomerAlertType {
  EMAIL = "email",
  SMS = "sms",
  WHATSAPP = "whatsapp",
}

export interface Config {
  id?: number;
  customer_id?: number;
  send_redemption_email?: boolean;
  coupon_redemption_enabled?: boolean;
  is_sez?: boolean;
  email?: string;
  from_email_name?: string;
  inventory_enabled?: boolean;
  gift_of_choice_enabled?: boolean;
  campaigns_enabled?: boolean;
  swagstore_enabled?: boolean;
  shopify_enabled?: boolean;
  alert_enabled?: boolean;
  alert_type?: CustomerAlertType | string;
  redemption_url?: string;
  linkedIn_id?: string;
  modified_by?: number;
  modifier_name?: string;
  created_date?: Date;
  modified_date?: Date;
  inventory_type?: string;
  redemption_email?: string;
  redirect_redemptions_to_linkedin?: boolean;
}
